import React from 'react'
import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import ChangeRequests from '@Scenes/RightsholderScene/ChangeRequests'
import ChangeRequestView from '@Scenes/RightsholderScene/ChangeRequests/View'

export const createChangeRequestRoutes = () => ({
    path: '',
    children: [
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalog.changeRequests.root,
            element: <ChangeRequests />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.catalog.changeRequests.view,
            element: <ChangeRequestView />,
        },
    ],
})
